module.exports = __webpack_public_path__ + "static/media/manitoba.07d46ba1.png";